import { render, staticRenderFns } from "./AsnUpload.vue?vue&type=template&id=5a58e52e&scoped=true&"
import script from "./AsnUpload.vue?vue&type=script&lang=js&"
export * from "./AsnUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a58e52e",
  null
  
)

export default component.exports